import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Users2: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[28px] h-[28px] stroke-[2px]', className)}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.8333 24.5V22.1667C19.8333 20.929 19.3417 19.742 18.4665 18.8668C17.5913 17.9917 16.4043 17.5 15.1667 17.5H5.83332C4.59565 17.5 3.40866 17.9917 2.53349 18.8668C1.65832 19.742 1.16666 20.929 1.16666 22.1667V24.5"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 15.3333C13.0773 15.3333 15.1667 13.244 15.1667 10.6667C15.1667 8.08934 13.0773 6 10.5 6C7.92268 6 5.83334 8.08934 5.83334 10.6667C5.83334 13.244 7.92268 15.3333 10.5 15.3333Z"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.5003 21.8483V19.515C26.4996 18.481 26.1554 17.4766 25.5219 16.6594C24.8884 15.8422 24.0015 15.2585 23.0003 15"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9997 6C18.0035 6.25702 18.8932 6.84082 19.5286 7.65936C20.1639 8.47791 20.5088 9.48463 20.5088 10.5208C20.5088 11.557 20.1639 12.5638 19.5286 13.3823C18.8932 14.2008 18.0035 14.7846 16.9997 15.0417"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Users2;
